import React from 'react';
import AppLogo from 'library/appLogo';

const SiteLogo = () => (
  <div className="bhp-site-logo">
    <AppLogo />
  </div>
);
export default SiteLogo;

